import WaybillDetailsModal from './index.vue'
export default WaybillDetailsModal